/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CRSFSecReviewAggregatedEnumerationResult } from './CRSFSecReviewAggregatedEnumerationResult';
import {
    CRSFSecReviewAggregatedEnumerationResultFromJSON,
    CRSFSecReviewAggregatedEnumerationResultFromJSONTyped,
    CRSFSecReviewAggregatedEnumerationResultToJSON,
} from './CRSFSecReviewAggregatedEnumerationResult';
import type { CRSFSecReviewEnumerationEvent } from './CRSFSecReviewEnumerationEvent';
import {
    CRSFSecReviewEnumerationEventFromJSON,
    CRSFSecReviewEnumerationEventFromJSONTyped,
    CRSFSecReviewEnumerationEventToJSON,
} from './CRSFSecReviewEnumerationEvent';
import type { CRSFSecReviewEnumerationStats } from './CRSFSecReviewEnumerationStats';
import {
    CRSFSecReviewEnumerationStatsFromJSON,
    CRSFSecReviewEnumerationStatsFromJSONTyped,
    CRSFSecReviewEnumerationStatsToJSON,
} from './CRSFSecReviewEnumerationStats';
import type { CRSFSecReviewIPDetails } from './CRSFSecReviewIPDetails';
import {
    CRSFSecReviewIPDetailsFromJSON,
    CRSFSecReviewIPDetailsFromJSONTyped,
    CRSFSecReviewIPDetailsToJSON,
} from './CRSFSecReviewIPDetails';

/**
 * 
 * @export
 * @interface Enumerated1
 */
export interface Enumerated1 {
    /**
     * 
     * @type {Array<CRSFSecReviewEnumerationEvent>}
     * @memberof Enumerated1
     */
    events: Array<CRSFSecReviewEnumerationEvent>;
    /**
     * 
     * @type {Array<string>}
     * @memberof Enumerated1
     */
    extra: Array<string>;
    /**
     * 
     * @type {{ [key: string]: CRSFSecReviewIPDetails; }}
     * @memberof Enumerated1
     */
    ip_details?: { [key: string]: CRSFSecReviewIPDetails; };
    /**
     * 
     * @type {string}
     * @memberof Enumerated1
     */
    query: string;
    /**
     * 
     * @type {CRSFSecReviewEnumerationStats}
     * @memberof Enumerated1
     */
    stats: CRSFSecReviewEnumerationStats;
    /**
     * 
     * @type {number}
     * @memberof Enumerated1
     */
    total: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof Enumerated1
     */
    wildcards?: Array<string>;
}

/**
 * Check if a given object implements the Enumerated1 interface.
 */
export function instanceOfEnumerated1(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "events" in value;
    isInstance = isInstance && "extra" in value;
    isInstance = isInstance && "query" in value;
    isInstance = isInstance && "stats" in value;
    isInstance = isInstance && "total" in value;

    return isInstance;
}

export function Enumerated1FromJSON(json: any): Enumerated1 {
    return Enumerated1FromJSONTyped(json, false);
}

export function Enumerated1FromJSONTyped(json: any, ignoreDiscriminator: boolean): Enumerated1 {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'events': ((json['events'] as Array<any>).map(CRSFSecReviewEnumerationEventFromJSON)),
        'extra': json['extra'],
        'ip_details': !exists(json, 'ip_details') ? undefined : (mapValues(json['ip_details'], CRSFSecReviewIPDetailsFromJSON)),
        'query': json['query'],
        'stats': CRSFSecReviewEnumerationStatsFromJSON(json['stats']),
        'total': json['total'],
        'wildcards': !exists(json, 'wildcards') ? undefined : json['wildcards'],
    };
}

export function Enumerated1ToJSON(value?: Enumerated1 | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'events': ((value.events as Array<any>).map(CRSFSecReviewEnumerationEventToJSON)),
        'extra': value.extra,
        'ip_details': value.ip_details === undefined ? undefined : (mapValues(value.ip_details, CRSFSecReviewIPDetailsToJSON)),
        'query': value.query,
        'stats': CRSFSecReviewEnumerationStatsToJSON(value.stats),
        'total': value.total,
        'wildcards': value.wildcards,
    };
}

